import React from 'react';
import Footer from '../components/footer';
import Header from '../components/header';

export default function ChildSafetyStandardsPage() {
  return (
    <div className="container">
      <Header />

      <div className="container-fluid mt-5 pt-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 border p-3">
            <section className="py-5">
              <div className="container">
                <div className="text-justify text-div">
                  <h2 className="mb-4">Child Safety Standards</h2>
                  <p className="lead">
                    These Child Safety Standards apply to the <strong>Clowza</strong> mobile app and the Clowza platform
                    (including clowza.com). Clowza is a scripture-based social platform. We have zero tolerance for
                    Child Sexual Abuse and Exploitation (CSAE).
                  </p>

                  <h4>1. Explicit prohibition of CSAE</h4>
                  <p>
                    Clowza strictly prohibits Child Sexual Abuse and Exploitation (CSAE), including any creation,
                    possession, distribution, solicitation, promotion, or sharing of Child Sexual Abuse Material (CSAM),
                    grooming, sexualization of minors, or any conduct that endangers children.
                  </p>
                  <p>
                    Users may not upload, post, message, link to, or otherwise circulate any content that depicts,
                    describes, or seeks sexual activity involving anyone under 18 years of age, whether real or
                    fictional.
                  </p>

                  <h4>2. Age and account expectations</h4>
                  <p>
                    Clowza is intended for adults and mature users who can participate responsibly in a faith-based
                    social community. Users must provide accurate account information. Accounts used to target,
                    exploit, or endanger minors are forbidden and will be removed.
                  </p>

                  <h4>3. Reporting child safety concerns</h4>
                  <p>
                    If you encounter suspected CSAE, CSAM, grooming, or any child safety risk on Clowza, report it
                    immediately using in-app reporting tools where available, or email our child safety contact:
                  </p>
                  <ul>
                    <li>Child safety / CSAE reports: <a href="mailto:clowzateam@gmail.com">clowzateam@gmail.com</a></li>
                    <li>General support: <a href="mailto:support@clowza.com">support@clowza.com</a></li>
                  </ul>
                  <p>
                    Please include links, usernames, screenshots, and any other details that help us investigate
                    quickly.
                  </p>

                  <h4>4. How Clowza responds to CSAM and CSAE</h4>
                  <p>
                    When Clowza obtains actual knowledge of CSAM or CSAE on our platform, we will take appropriate action, which may include:
                  </p>
                  <ul>
                    <li>Removing the content</li>
                    <li>Restricting or permanently banning the responsible account(s)</li>
                    <li>Preserving relevant records as required for investigations</li>
                    <li>Reporting confirmed CSAM to the National Center for Missing &amp; Exploited Children (NCMEC) or another relevant regional authority, as required by applicable law</li>
                    <li>Cooperating with lawful requests from authorities</li>
                  </ul>

                  <h4>5. Compliance with child safety laws</h4>
                  <p>
                    Clowza is committed to complying with applicable child safety laws and regulations related to
                    CSAE and CSAM. We maintain processes to review reports, remove violating content, and escalate
                    confirmed CSAM to the appropriate authorities.
                  </p>

                  <h4>6. User responsibilities</h4>
                  <ul>
                    <li>Do not create, share, request, or engage with CSAE or CSAM in any form</li>
                    <li>Do not attempt to contact or exploit minors</li>
                    <li>Report suspected violations promptly</li>
                    <li>Do not misuse reporting tools</li>
                  </ul>

                  <h4>7. Enforcement</h4>
                  <p>
                    Violations of these Child Safety Standards may result in content removal, account suspension or
                    termination, and referral to law enforcement where appropriate. Clowza may act on reports from
                    users, moderators, automated signals, or notices from Google Play and other partners.
                  </p>

                  <h4>Contact and publisher details</h4>
                  <ul>
                    <li><strong>App name:</strong> Clowza</li>
                    <li><strong>Developer / publisher:</strong> Clowza</li>
                    <li><strong>Child safety point of contact:</strong> <a href="mailto:clowzateam@gmail.com">clowzateam@gmail.com</a></li>
                    <li><strong>Website:</strong> <a href="https://clowza.com">https://clowza.com</a></li>
                    <li>
                      <strong>Canonical public standards URL:</strong>{' '}
                      <a href="https://clowza.com/child-safety-standards.html">
                        https://clowza.com/child-safety-standards.html
                      </a>
                    </li>
                  </ul>

                  <p className="mt-4 text-muted">
                    Last Updated: August 8, 2026
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
